const SebiCircular = () => {
    return (
        <div className="bg-gray-100 dark:bg-gray-900">
        <div className="container mx-auto px-4 py-8 lg:px-32 xl:px-48 dark:text-gray-400">
          <h1 className="text-3xl font-bold mb-4 dark:text-gray-200 text-center">SEBI CIRCULAR FOR ALGORITHM COMPANY'S</h1>
  
          <br />

          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">SEBI/HO/MIRSD/DOP/P/CIR/2022/117</h2>

          <p className="mb-4 ">
          We follow all the rules laid down by SEBI. We do not liar anyone with huge profits. You can trade through the software provided by us. In this you do not need to watch the market throughout the day. You can set a limit in this. With some portfolio after which automatic trading will continue to happen in your account and whatever profit and loss you will make at the end of the day. It will appear in your account. We have integrated all the SEBI protocols in the website as well as the document so that the customer gets all the information before entering into an agreement with us. We don’t believe in tricking anyone into becoming a customer. Only that fact will be told to you. All our agents are NISM certified.
          </p>
  
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">SEBI CIRCULAR September 02, 2022</h2>

            <ol className="list-decimal list-inside mb-4">
            <li>
                It has come to the notice of the Securities and Exchange Board of India (SEBI) that some unregulated platforms are offering algorithmic trading services/strategies to investors for automated execution of trades. Such services and strategies are being marketed with “claims” of high returns on investment. Further, “ratings” have been assigned to the strategies, which could lead to investors being lured by such claims. This may amount to mis-selling of such services and strategies to investors.
            </li>
            <li>
                In this regard, SEBI had cautioned investors against dealing with such unregulated platforms offering algorithmic trading services/strategies vide Press Release No. 20/2022 dated June 10, 2022.
            </li>
            <li>
                It has also come to notice of SEBI that stock brokers provide algorithmic trading facility to investors through such platforms.
            </li>
            <li>
                In order to prevent such acts and instances of mis-selling and to protect the interest of investors in the securities market, it has been decided that:
                <ol className="list-inside mb-4">
                <li>(4.1). Stock Brokers who provide services relating to algorithmic trading shall not:
                    <ol>
                    <li>(4.1.1). directly or indirectly make any reference to the past or expected future return/performance of the algorithm; and/or</li>
                    <li>(4.1.2). directly or indirectly associate with any platform providing any reference to the past or expected future return/performance of the algorithm.</li>
                    </ol>
                </li>
                <li>
                    (4.2). Stock brokers who are directly/indirectly referring to any past or expected future return/performance of an algorithm or are associated with any platform providing such reference, shall remove the same from their website and/or disassociate themselves from the platforms providing such references, as the case may be, within seven days from the date of this circular.
                </li>
                </ol>
            </li>
            <li>
                Stock exchanges, are hereby, directed to:
                <ol>
                <li>(5.1). take necessary steps and put in place necessary systems and procedures for implementation of the above provisions;</li>
                <li>(5.2). make necessary amendments to the relevant bye-laws, rules and regulations for the implementation of the above provisions;</li>
                <li>(5.3). bring the provisions of this circular to the notice of stock brokers and disseminate the same on their website;</li>
                <li>(5.4). monitor compliance of this circular by taking confirmation from stock brokers that they are compliant with clause 4.1 and 4.2 of this circular along with the proof of the same; and shall submit a compliance report to SEBI in this regard within 60 days from the date of this Circular.</li>
                </ol>
            </li>
            </ol>



          <p className="mb-4">
          The provisions of this circular shall be applicable with immediate effect.
          </p>
        
          <p className="mb-4">
          Appropriate action may be taken by SEBI under the securities laws for non compliance of the above provisions.
          </p>

          <p className="mb-4">
          This circular is issued in exercise of powers conferred under Section 11(1) of the Securities and Exchange Board of India Act, 1992, to protect the interests of investors in securities and to promote the development of, and to regulate the securities markets.
          </p>
        </div>
      </div>
    )
};

export default SebiCircular;